<div class="wrapper-app">
  <flow-header></flow-header>
  <div class="d-flex">
    <flow-sidebar *ngIf="sessionSrv.isAuthenticated"></flow-sidebar>
    <div class="content" *ngIf="sessionSrv.isAuthenticated"><router-outlet/></div>
    <!-- Sign In Overlayer -->
    <flow-sign-in class="sign-in" *ngIf="!sessionSrv.isAuthenticated"></flow-sign-in>
  </div>
</div>
